import Service from '../Service'
class ItemService extends Service {
  constructor() {
    super()
    this.resource = 'items'
  }

  hasParameter(string) {
    if (string.substr(string.length - 1) === '?') return false
    return true
  }

  createRequestUrl(query) {
    let requestUrl = query.pdvBalcao
      ? `${this.resource}/indexPdvBalcao?`
      : `${this.resource}?`

    if (query) query = this.encodeQueryValues(query)

    if (query.tipoPreco)
      requestUrl += this.hasParameter(requestUrl)
        ? `&TIPOPRECO=${query.tipoPreco}`
        : `TIPOPRECO=${query.tipoPreco}`
    if (parseInt(query.moedaBalcao) >= 0)
      requestUrl += this.hasParameter(requestUrl)
        ? `&MOEDABALCAO=${query.moedaBalcao}`
        : `MOEDABALCAO=${query.moedaBalcao}`
    if (query.descricao)
      requestUrl += this.hasParameter(requestUrl)
        ? `&DESCRICAO=${query.descricao}`
        : `DESCRICAO=${query.descricao}`
    if (query.hibrido)
      requestUrl += this.hasParameter(requestUrl)
        ? `&HIBRIDO=${query.hibrido}`
        : `HIBRIDO=${query.hibrido}`
    if (query.codigo)
      requestUrl += this.hasParameter(requestUrl)
        ? `&CODIGO=${query.codigo}`
        : `CODIGO=${query.codigo}`
    if (query.ncm)
      requestUrl += this.hasParameter(requestUrl)
        ? `&NBM=${query.ncm}`
        : `NBM=${query.ncm}`
    if (query.fabricante)
      if (query.fabricante.value)
        requestUrl += this.hasParameter(requestUrl)
          ? `&FABRICANTE=${encodeURIComponent(query.fabricante.value)}`
          : `FABRICANTE=${encodeURIComponent(query.fabricante.value)}`
      else
        requestUrl += this.hasParameter(requestUrl)
          ? `&FABRICANTE=${query.fabricante}`
          : `FABRICANTE=${query.fabricante}`
    if (query.grupo)
      if (query.grupo.value)
        requestUrl += this.hasParameter(requestUrl)
          ? `&GRUPO=${encodeURIComponent(query.grupo.value)}`
          : `GRUPO=${encodeURIComponent(query.grupo.value)}`
      else
        requestUrl += this.hasParameter(requestUrl)
          ? `&GRUPO=${query.grupo}`
          : `GRUPO=${query.grupo}`
    if (query.marca)
      if (query.marca.value)
        requestUrl += this.hasParameter(requestUrl)
          ? `&MARCA=${encodeURIComponent(query.marca.value)}`
          : `MARCA=${encodeURIComponent(query.marca.value)}`
      else
        requestUrl += this.hasParameter(requestUrl)
          ? `&MARCA=${query.marca}`
          : `MARCA=${query.marca}`
    if (query.page)
      requestUrl += this.hasParameter(requestUrl)
        ? `&page=${query.page}`
        : `page=${query.page}`

    // teste para trazer mais itens no combobox
    if (query.perPage)
      requestUrl += this.hasParameter(requestUrl)
        ? `&PER_PAGE=${query.perPage}`
        : `PER_PAGE=${query.perPage}`

    // para atualizar preços no indexPdvBalcao
    if (query.condicaoPgto)
      requestUrl += this.hasParameter(requestUrl)
        ? `&condicaopgto=${encodeURIComponent(query.condicaoPgto.CODIGO)}`
        : `condicaopgto=${encodeURIComponent(query.condicaoPgto.CODIGO)}`

    // para filtar só itens com saldo
    if (query.comsaldo)
      requestUrl += this.hasParameter(requestUrl)
        ? `&SALDO=${query.comsaldo}`
        : `SALDO=${query.comsaldo}`

    // para filtar só itens em oferta
    if (query.soemoferta)
      requestUrl += this.hasParameter(requestUrl)
        ? `&SOEMOFERTA=${query.soemoferta}`
        : `SOEMOFERTA=${query.soemoferta}`

    // para filtar só itens com imagens
    if (query.socomimagens)
      requestUrl += this.hasParameter(requestUrl)
        ? `&SOCOMIMAGENS=${query.socomimagens}`
        : `SOCOMIMAGENS=${query.socomimagens}`

    // para filtar nome da oferta
    if (query.nameoferta)
      requestUrl += this.hasParameter(requestUrl)
        ? `&NOMEOFERTA=${query.nameoferta}`
        : `NOMEOFERTA=${query.nameoferta}`

    if (query.produtoservico)
      requestUrl += this.hasParameter(requestUrl)
        ? `&PRODUTOSERVICO=${query.produtoservico}`
        : `PRODUTOSERVICO=${query.produtoservico}`

    // para trazer os dados do item_integracao
    if (query.comitemintegracao)
      requestUrl += this.hasParameter(requestUrl)
        ? `&COMITEMINTEGRACAO=${query.comitemintegracao}`
        : `COMITEMINTEGRACAO=${query.comitemintegracao}`
    return requestUrl
  }

  async getItens(query = null) {
    let requestUrl = this.createRequestUrl(query)
    return await this.getAPI(requestUrl)
  }

  async getItem(payload) {
    let requestUrl = `/${this.resource}/${encodeURIComponent(payload)}`
    return await this.getAPI(requestUrl)
  }
}

export default new ItemService()
